import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import SiteLayout from "./components/site/SiteLayout";
import { LangProvider } from "./lib/i18n";
import Home from "./pages/public/Home";
import PackPage from "./pages/public/PackPage";
import { OfferPage, TopicPage, ZonesIndex, Atelier, Realisations, CaseDetail, Faq, Legal, NotFound } from "./pages/public/Pages";
import { Demande, DemandeChoice, Confirmation, ProjectPage } from "./pages/public/Demande";
import Products from "./pages/public/Products";
import ProductPage from "./pages/public/ProductPage";
import AdminProducts from "./pages/admin/Products";
import Leads from "./pages/admin/Leads";
import { Conseils, Article } from "./pages/public/Conseils";
import { ClientLogin, ClientAccess, ClientDossiers } from "./pages/client/Client";
import ClientDossier from "./pages/client/ClientDossier";
import { StaffProvider, AdminLogin, AdminLayout } from "./pages/admin/AdminShell";
import Dashboard from "./pages/admin/Dashboard";
import Dossiers from "./pages/admin/Dossiers";
import Dossier from "./pages/admin/Dossier";
import ProductionSheet from "./pages/admin/ProductionSheet";
import Stats from "./pages/admin/Stats";
import SettingsPage from "./pages/admin/Settings";
import AdminCases from "./pages/admin/Cases";
import Calculators from "./pages/admin/Calculators";
import Landing from "./pages/public/Landing";
import { OFFERS } from "./content/site";
import { OLD_REDIRECTS as OLD } from "./content/redirects";

function App() {
  return (
    <div className="App">
      <LangProvider>
      <BrowserRouter>
        <StaffProvider>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route index element={<Home />} />
              {Object.entries(OFFERS).map(([k, o]) => <Route key={k} path={o.path} element={<OfferPage k={k} />} />)}
              <Route path="/savoir-faire/:b" element={<TopicPage a="savoir-faire" />} />
              <Route path="/secteurs/:b" element={<TopicPage a="secteurs" />} />
              <Route path="/zones" element={<ZonesIndex />} />
              <Route path="/zones/:b" element={<TopicPage a="zones" />} />
              <Route path="/personnalisation/:slug" element={<Landing />} />
              <Route path="/atelier" element={<Atelier />} />
              <Route path="/produits" element={<Products />} />
              <Route path="/produits/:slug" element={<ProductPage />} />
              <Route path="/pack/:id" element={<PackPage />} />
              <Route path="/realisations" element={<Realisations />} />
              <Route path="/realisations/:slug" element={<CaseDetail />} />
              <Route path="/conseils" element={<Conseils />} />
              <Route path="/conseils/:slug" element={<Article />} />
              <Route path="/questions-frequentes" element={<Faq />} />
              <Route path="/mentions-legales" element={<Legal kind="legal" />} />
              <Route path="/confidentialite" element={<Legal kind="privacy" />} />
              <Route path="/demande" element={<DemandeChoice />} />
              <Route path="/projet-particulier" element={<ProjectPage />} />
              <Route path="/demande/confirmation" element={<Confirmation />} />
              <Route path="/demande/:offer" element={<Demande />} />
              <Route path="/espace-client" element={<ClientLogin />} />
              <Route path="/espace-client/acces" element={<ClientAccess />} />
              <Route path="/espace-client/dossiers" element={<ClientDossiers />} />
              <Route path="/espace-client/dossiers/:id" element={<ClientDossier />} />
              {OLD.filter(([from]) => !from.includes("*")).map(([from, to]) => <Route key={from} path={from} element={<Navigate to={to} replace />} />)}
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="dossiers" element={<Dossiers />} />
              <Route path="dossiers/:id" element={<Dossier />} />
              <Route path="dossiers/:id/fiche" element={<ProductionSheet />} />
              <Route path="statistiques" element={<Stats />} />
              <Route path="realisations" element={<AdminCases />} />
              <Route path="produits" element={<AdminProducts />} />
              <Route path="contacts" element={<Leads />} />
              <Route path="calculateurs" element={<Calculators />} />
              <Route path="parametres" element={<SettingsPage />} />
            </Route>
          </Routes>
        </StaffProvider>
        <Toaster position="bottom-right" />
      </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
